import React, { FunctionComponent, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../App/Components/Form/TextInput/TextInput'

import { IProps } from './IProps'

export const ConfirmPasswordInputField: FunctionComponent<IProps> = ({
    personPassword,
    personPasswordConfirm,
    setPersonPasswordConfirm,
    setPasswordMatchError,
}) => {
    const { t } = useTranslation()

    useEffect(() => {
        if (personPasswordConfirm !== personPassword) {
            setPasswordMatchError(`${t('Passwords do not match')}`)
        } else {
            setPasswordMatchError('')
        }

        if (personPasswordConfirm.length === 0) {
            setPasswordMatchError('')
        }
    }, [personPassword, personPasswordConfirm, setPasswordMatchError, t])

    return (
        <div
            style={{
                margin: '0.7em 0',
            }}
        >
            <TextInput
                label={t('Confirm password *')}
                isRequired={true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setPersonPasswordConfirm(e.currentTarget.value)

                    if (e.currentTarget.value.length === 0) {
                        setPasswordMatchError('')
                    }
                }}
                type={'password'}
            />
        </div>
    )
}
